import { styled } from '@mui/material/styles';
import isPropValid from '@emotion/is-prop-valid';

export const StyledItem = styled('a', { shouldForwardProp: isPropValid })(
  ({ theme, darkMode, selected, isAnySelected }) => ({
    borderRadius: '5px',
    marginLeft: '8px',
    marginRight: '8px',
    marginTop: isAnySelected ? '10px' : 0,
    padding: '24px 8px',
    width: 'calc(100% - 16px)',
    height: isAnySelected ? 'calc(100% - 20px)' : '100%',
    border: selected ? `3px solid ${theme.palette.primary.main}` : '1px solid rgba(0,0,0,.125)',
    background: darkMode ? theme.palette.neutral[700] : theme.palette.neutral[50],
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& img': {
      margin: 'auto',
      paddingBottom: '1rem',
      maxWidth: '40px',
    },
    [theme.breakpoints.up('md')]: {
      '& img': {
        maxWidth: '60px',
      },
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '12rem',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    '.slick-slide &:hover, .slick-slide & > span:hover': {
      color: darkMode ? theme.palette.neutral[50] : theme.palette.neutral[800],
    },
  }),
);

export const ArrowDown = styled('div')(({ theme }) => ({
  width: 0,
  height: 0,
  borderLeft: '10px solid transparent',
  borderRight: '10px solid transparent',
  borderTop: `10px solid ${theme.palette.primary.main}`,
  margin: 'auto',
}));

export const CategorySliderContainer = styled('section', { shouldForwardProp: isPropValid })(
  ({ theme, darkMode }) => ({
    background: darkMode ? theme.palette.neutral[800] : 'none',
    padding: '4rem 4rem',
    overflow: 'hidden',

    [theme.breakpoints.only('xs')]: {
      padding: '4rem 0',
      '& .slick-slide:first-of-type': {
        marginLeft: '20vw',
      },
      '& .slick-slide:last-of-type': {
        marginRight: '28px',
      },
      '& .slick-arrow': {
        visibility: 'hidden',
      },
    },
    '& .slick-slide > div': {
      flex: 1,
    },
    '&.overlap': {
      position: 'relative',
      background: 'none',
      zIndex: 20,
      left: 0,
      top: '-80px',
    },
  }),
);
